const color = {
    50: '#DBEBFF',
    300: '#B7D7FF',
    400: '#92C2FF',
    500: '#6EAEFF',
    700: '#4A9AFF', // Main
    900: '#346CB3'
};
export default color;
